import { Create } from '@refinedev/antd'
import { useForm } from '@refinedev/antd'
import { CourseForm } from './Form'
import { ICourse } from 'interfaces/catering'
import { COURSE_URL } from 'urls'

export const CourseCreate: React.FC = () => {
  const formProps = useForm<ICourse>({ resource: COURSE_URL })

  return (
    <Create>
      <CourseForm useFormProps={formProps} />
    </Create>
  )
}
